import createActions from 'utils/redux/createActions'

export default createActions([
	'ERROR'
])



// WEBPACK FOOTER //
// ./src/actions/error.js